<!-- This component is a modern approach to the `donut-form-item`. We want a cohesive "form section" for our pages, but many of these
of these are async and not part of any form to speak of. More still are styled differently (no icons, more funcionality on the left side). -->
<template>
  <div class="f-as f-sb">
    <div class="flexed f-v w-x40 w-min-x40 w-max-x40 h-min-x5">
      <div v-if="props.title" class="t-xl bold m-bx1">{{ props.title }}</div>
      <slot name="left-side">
        <div class="t dark-gray">{{ props.description }}</div>
      </slot>
    </div>
    <div class="flexed w-x50 w-min-x50 w-max-x50 f-v f-ast">
      <slot name="right-side" />
    </div>
  </div>
</template>

<script setup>
  const props = defineProps({
    title: { type: String, default: null },
    description: { type: String, default: null },
  });
</script>
